import {
  ChevronLeft,
  ChevronRight,
  Building2,
  Database,
  MessageSquare,
  Plus,
  ChevronDown,
  ChevronRight as ArrowRight,
} from "lucide-react";
import { useState } from "react";

export default function ExpandedLeftPanel({
  chats,
  activeChatId,
  loadChat,
  onNewChat,
  mode,
  setMode,
  onClearFollowup,
  hasTyped,
  handleModeChange,
}) {
  const [open, setOpen] = useState(true);
  const [search, setSearch] = useState("");
  const [showHistory, setShowHistory] = useState(true);
  const filteredChats = chats.filter((c) =>
    c.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={`left-panel ${open ? "open" : "closeSidebad"}`}>
      {/* <div className="panel-header">
        <div className="base-header" style={{ cursor: "pointer" }}>
          <Building2 className="icon" size={30} />
        </div>

        <button className="toggle-btn-chat" onClick={() => setOpen(!open)}>
          {open ? <ChevronLeft size={25} /> : <ChevronRight size={25} />}
        </button>
      </div> */}
      <div className="panel-header">
        {open ? (
          <div className="base-header" style={{ cursor: "pointer" }}>
            <Building2 className="icon" size={30} />
          </div>
        ) : (
          <div
            className="collapsed-icon"
            onClick={() => setOpen(true)}
            style={{ cursor: "pointer" }}
          >
            <ChevronRight size={25} />
          </div>
        )}

        {open && (
          <button className="toggle-btn-chat" onClick={() => setOpen(false)}>
            <ChevronLeft size={25} />
          </button>
        )}
      </div>

      <ul className="menu">
        <li onClick={onNewChat} className="clickable">
          <Plus size={20} />
          {open && <span>New Chat</span>}
        </li>

        <li
          onClick={() => handleModeChange("business")}
          className={`clickable ${mode === "business" ? "active" : ""}`}
        >
          <MessageSquare size={20} />
          {open && <span>Business</span>}
        </li>

        <li
          onClick={() => handleModeChange("collection")}
          className={`clickable ${mode === "collection" ? "active" : ""}`}
        >
          <Database size={20} />
          {open && <span>Collections</span>}
        </li>

        {open && (
          <li
            className="chat-toggle"
            onClick={() => setShowHistory(!showHistory)}
            style={{
              alignItems: "center",
              marginTop: "4px",
              paddingRight: "10px",
              cursor: "pointer",
            }}
          >
            <span>Your Chats</span>
            {showHistory ? <ChevronDown size={16} /> : <ArrowRight size={16} />}
          </li>
        )}

        {open && showHistory && (
          <div
            className="chat-history"
            style={{ maxHeight: "calc(100vh - 400px)" }}
          >
            {filteredChats.map((chat) => (
              <li
                key={chat.id}
                className={`chat-item ${
                  chat.id === activeChatId ? "active" : ""
                }`}
                onClick={() => loadChat(chat.id)}
                title={chat.title}
              >
                {/* <MessageSquare size={14} style={{ flexShrink: 0 }} /> */}
                {open && <span>{chat.title?.slice(0,35)}</span>}
              </li>
            ))}
          </div>
        )}
      </ul>
    </div>
  );
}
